import { useStore } from 'zustand';
import { identity } from 'ramda';

import { useDependencies } from '@/scopes/common/infrastructure/dependencies';
import type { PricesStore } from './store';

export const usePricesStore = () => {
  const { pricesStore } = useDependencies();
  return useStore(pricesStore, identity<PricesStore>);
};

export const usePricesStoreSelector = <T>(selector: (state: PricesStore) => T): T => {
  const store = usePricesStore();
  return selector(store);
};
